import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      $gm_router_coverage: 'addresses/getCoverageType',
      $gm_router_package: 'simulation/getPackage'
    }),
    $gm_router_packageRoot() {
      if (!this.$gm_router_package) {
        return null;
      }

      return this.$gm_router_package.split('.')[0];
    }
  },
  methods: {
    $gm_router_push(name, params) {
      this.$router.push({
        name,
        params: {
          coverage: this.$gm_router_coverage,
          package: this.$gm_router_packageRoot,
          ...params
        }
      });
    },
    $gm_router_replace(name) {
      this.$router.replace({
        name,
        params: {
          coverage: this.$gm_router_coverage,
          package: this.$gm_router_packageRoot
        }
      });
    },
    $gm_router_goBack() {
      this.$router.push({
        name: this.route.from.name,
        params: {
          coverage: this.$gm_router_coverage,
          package: this.$gm_router_packageRoot
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/mixins/global/router.js